module.exports = __webpack_public_path__ + "img/graphics-server.b7c435e.webp";